module.exports = __webpack_public_path__ + "media/Images/icon-save-b33915f2cde93a8799433c96eaadf933.svg";